const EmailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export default EmailRegex;